import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch, useSelector } from "react-redux";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Col, Row } from "react-bootstrap";

import { centersActions, paymentActions } from "../../../../../redux/actions";
import { allSharedComponents } from "../../../../../shared";
import {
  appendMandatorySignAndTimezoneText,
  serverFormatToDateString,
  unloadWidget,
} from "../../../../../system";
import {
  translationConstants,
  paymentType,
  timezoneConstants,
  CenterStatusEnum,
} from "../../../../../constants";
import {
  loadingIndicator,
  dataEndMessage,
} from "../../../../../shared/utilitiies";
import {
  TickIcon,
  AddSquareIcon,
  LockIcon,
  EditIcon,
} from "../../../../../assets/images/icon";

const {
  BaseForm,
  CustomModal,
  SaveCardModal,
  SaveCard,
  TimezoneDisplayText,
  InvoiceDetail,
  ConfirmationModal,
} = allSharedComponents;

const initialGridState = {
  length: 7,
  search: null,
  pageNumber: 1,
  orderBy: "id desc",
  filterQuery: "",
};

const MembershipTab = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [showSaveCardModal, setShowSaveCardModal] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [selectCardId, setSelectedCardId] = useState("");
  const [gridState, setGridState] = useState(initialGridState);
  const [isModalOpen, setModalOpen] = useState(false);

  const systemUserId = useSelector(
    (state) => state.LoginReducer.UserData.user.centerId
  );
  const paymentHistory = useSelector(
    (state) => state.PaymentReducer.paymentHistory?.pageData
  );
  const paymentHistoryStats = useSelector(
    (state) => state.PaymentReducer.paymentHistoryStats
  );
  const savedCards = useSelector(
    (state) => state.PaymentReducer.savedPaymentCards?.data
  );

  const getMoreInvoices = () => {
    const updatedGridState = { ...gridState, length: gridState.length + 7 };
    setGridState(updatedGridState);
  };

  useEffect(() => {
    dispatch(
      paymentActions.paymentHistoryStats({
        centerId: systemUserId ? systemUserId : props.centerId,
        paymentType: paymentType.Center,
      })
    );
    dispatch(
      paymentActions.getSavedPaymentCard({
        centerId: systemUserId ? systemUserId : props.centerId,
      })
    );
    /*eslint-disable-next-line */
  }, []);

  useEffect(() => {
    dispatch(
      paymentActions.paymentHistory({
        centerId: systemUserId ? systemUserId : props.centerId,
        paymentType: paymentType.Center,
        params: gridState,
      })
    );
    /*eslint-disable-next-line */
  }, [gridState]);

  const cancelMembershipSubscription = () => {
    dispatch(
      centersActions.cancelMembership(props.centerId, () => {
        dispatch(centersActions.getCenterById(props.centerId));
      })
    );
  };

  return (
    <>
      <div className="row w-100">
        <div className="col-md-8 border-vr-right order-1 order-md-0">
          <div className="m-l-22 m-r-22">
            {props.centerStatus !== CenterStatusEnum.Restricted &&
              props.centerStatus !== CenterStatusEnum.PaymentPending && (
                <>
                  <Row className="align-items-center">
                    <Col xs={4} lg={3}>
                      <p className="membership-head">
                        {t(translationConstants.SSF_MEMBER_SHIP)}
                      </p>
                    </Col>
                    <Col
                      xs={4}
                      md="auto"
                      className="d-flex justify-content-start"
                    >
                      <span className="m-l-14 membership-learn-more-rtl">
                        <a className="membership-learn-more cursor-not-allowed">
                          {t(translationConstants.LEARN_MORE)}
                        </a>
                      </span>
                    </Col>
                    {props.centerStatus === CenterStatusEnum.Approved && (
                      <Col className="d-flex justify-content-end">
                        <span
                          role="button"
                          className="m-l-14 membership-learn-more"
                          onClick={() => {
                            setModalOpen(true);
                          }}
                        >
                          {t(translationConstants.CANCEL_MEMBERSHIP)}
                        </span>
                      </Col>
                    )}
                  </Row>
                  <hr className="w-100 membership-hr" />
                  <div>
                    <p className="membership-yearly">
                      {t(translationConstants.MEMBER_SHIP_YEARLY_BILLING)}
                    </p>
                  </div>
                  <Row className="m-t-24 membership-line-height">
                    <Col xs={8} sm={6} lg={4}>
                      <p className="membersip-yearly-pay">
                        <strong>
                          {t(translationConstants.YEARLY_PAYMENT)}:
                        </strong>
                      </p>
                    </Col>
                    {paymentHistoryStats?.yearlyAmount && (
                      <Col
                        xs={4}
                        md="auto"
                        className="d-flex justify-content-start"
                      >
                        <p className="membership-yearly-pay-text">{`${translationConstants.SAR} ${paymentHistoryStats?.yearlyAmount}`}</p>
                      </Col>
                    )}
                  </Row>
                  <Row className="membership-line-height">
                    <Col xs={8} sm={6} lg={4}>
                      <p className="membersip-yearly-pay">
                        <strong>
                          {appendMandatorySignAndTimezoneText(
                            t(translationConstants.NEXT_PAYMENT_DUE),
                            t,
                            false,
                            "font-12"
                          )}
                        </strong>
                      </p>
                    </Col>
                    {paymentHistoryStats?.nextDueDateString && (
                      <Col
                        xs={4}
                        md="auto"
                        className="d-flex justify-content-start"
                      >
                        <p className="membership-yearly-pay-text">
                          {serverFormatToDateString(
                            paymentHistoryStats?.nextDueDateString,
                            timezoneConstants.dayMonthYearFormat
                          )}
                        </p>
                      </Col>
                    )}
                  </Row>
                </>
              )}

            <div className="m-t-24">
              <h6 className="membership-pay_history">
                {t(translationConstants.PAYMENT_HISTORY)}
              </h6>
              <TimezoneDisplayText />
              <hr className="membership-hr" />

              <InfiniteScroll
                dataLength={paymentHistory?.length ?? 0}
                next={getMoreInvoices}
                hasMore={
                  paymentHistory?.length % 7 === 0 &&
                  paymentHistory?.length !== 0
                    ? true
                    : false
                }
                loader={loadingIndicator(t)}
                endMessage={dataEndMessage(t, paymentHistory)}
                style={{ overflow: "hidden" }}
                scrollableTarget={"main-container"}
              >
                <div className="row m-0 w-100 invoice">
                  <div className="d-flex">
                    <Col>
                      <div className="text-decoration-underline t-head invoice-column">
                        {t(translationConstants.YEAR)}
                      </div>
                    </Col>
                    <Col xs={7} sm={6} md={5} lg={4} xxl={3}>
                      <div className="text-decoration-underline t-head invoice-column">
                        {t(translationConstants.PAYMENT_TYPE)}
                      </div>
                    </Col>
                    <Col>
                      <div className="text-decoration-underline t-head invoice-column text-center">
                        {t(translationConstants.AMOUNT)}
                      </div>
                    </Col>
                    <Col>
                      <div className="text-decoration-underline t-head invoice-column">
                        {t(translationConstants.DATE)}
                      </div>
                    </Col>
                    <Col>
                      <div className="text-decoration-underline t-head invoice-column">
                        {t(translationConstants.INVOICE)}
                      </div>
                    </Col>
                  </div>

                  {paymentHistory?.map((paymentHistory) => {
                    return <InvoiceDetail paymentHistory={paymentHistory} />;
                  })}
                </div>
              </InfiniteScroll>
            </div>
          </div>
        </div>

        <div className="col-md-4 p-l-22 p-r-22 order-0 order-md-1 pb-5">
          <div className="row w-100 membership-border-bottom">
            <div className="col-6 d-flex flex-column">
              <p className="card-detail">
                {t(translationConstants.CARD_DETAILS)}
              </p>
              <span className="card-secured pb-1">
                <img src={LockIcon} alt="img-lock" />
                {t(translationConstants.SECURED_BY)}
              </span>
            </div>
            <div className="col-6 card-div-display justify-content-end">
              <span className="card-update">
                {isUpdate ? (
                  <span
                    className="cursor-pointer"
                    onClick={() => {
                      dispatch(
                        paymentActions.updateSavedCard(selectCardId, {
                          centerId: systemUserId
                            ? systemUserId
                            : props.centerId,
                        })
                      );
                      setIsUpdate(false);
                    }}
                  >
                    <img
                      className="height-width-23"
                      src={TickIcon}
                      alt="secure lock icon"
                    />
                  </span>
                ) : (
                  <span
                    className="cursor-pointer"
                    onClick={() => setIsUpdate(true)}
                  >
                    <img
                      className="height-width-25"
                      src={EditIcon}
                      alt="EditIcon"
                    />
                  </span>
                )}
                <span
                  className="cursor-pointer"
                  onClick={() => {
                    setShowSaveCardModal(true);
                  }}
                >
                  <img
                    className="height-width-20"
                    src={AddSquareIcon}
                    alt="AddSquareIcon"
                  />
                </span>
              </span>
            </div>
          </div>

          {savedCards?.map((savedCards) => {
            return (
              <SaveCard
                savedCard={savedCards}
                isUpdate={isUpdate}
                setSelectedCardId={setSelectedCardId}
                selectCardId={selectCardId}
                centerId={props.centerId}
              />
            );
          })}
        </div>
      </div>
      <CustomModal
        scrollable={true}
        size="sm"
        setShow={setShowSaveCardModal}
        show={showSaveCardModal}
        customClass="view-user-modal"
      >
        <BaseForm customClass="payment-modal-min-height pt-5">
          <SaveCardModal
            title={t(translationConstants.SAVE_CARD_DETAIL)}
            isCenter={true}
            onCancel={() => {
              setShowSaveCardModal(!showSaveCardModal);
              unloadWidget();
            }}
            onSubmit={() => {
              setShowSaveCardModal(!showSaveCardModal);
              unloadWidget();
            }}
          />
        </BaseForm>
      </CustomModal>

      <CustomModal
        scrollable={true}
        size="md"
        setShow={() => setModalOpen(!isModalOpen)}
        show={isModalOpen}
        customClass="view-user-modal"
      >
        <ConfirmationModal
          title={t(translationConstants.CANCEL_MEMBERSHIP)}
          messageLine1={t(translationConstants.ARE_YOU_SURE_CANCEL_MEMBERSHIP)}
          onCancel={() => setModalOpen(!isModalOpen)}
          onSubmit={() => {
            cancelMembershipSubscription();
            setModalOpen(!isModalOpen);
          }}
        />
      </CustomModal>
    </>
  );
};

export default MembershipTab;
